import { AbstractCollection } from '../../../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable } from '../../../../abstract/Document';
import { Weddings } from '../../../Weddings';
import type { Conversation } from '../Conversations';
import type { IMessage } from './Messages.types';

@Identifiable
@Timestampable
export class Message extends AbstractDocument<IMessage> {
  readonly collections = {};

  get agent() {
    return this.conversation.agent;
  }

  get conversation() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents).Conversations.getById(this.ids.conversations);
  }

  get wedding() {
    return this.agent.wedding;
  }

  /**
   * Determines whether the conversation should be compacted based on the number of messages and the last updated date.
   */
  async shouldCompact(): Promise<boolean> {
    const snapshot = await this.get(true);

    /**
     * Force compaction if there are more than 128 messages in the conversation.
     * The 128 message limit is arbitrary, but it is a reasonable limit to prevent conversations from growing too large.
     */
    if (snapshot.messages.length >= 128) {
      return true;
    }

    const today = new Date().toISOString().substring(0, 10);

    /**
     * Force daily compaction.
     */
    if (today !== (snapshot.updatedAt ?? snapshot.createdAt).toDate().toISOString().substring(0, 10)) {
      return true;
    }

    return false;
  }
}

export class Messages extends AbstractCollection<Message, IMessage> {
  static path = 'messages';

  constructor(document: Conversation) {
    super(document.collection(Messages.path), Message);
  }

  get agent() {
    return this.conversation.agent;
  }

  get conversation() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents).Conversations.getById(this.ids.conversations);
  }

  get wedding() {
    return this.agent.wedding;
  }
}
